import React from 'react';
import Text from '@components/paragraphs/text';
import renderModule from './render-module';
import { Wrapper, Info, SectionMetaContainer, StyledCopy, Summary, Content, Notes } from './module.styled';
var Module = function Module(_ref) {
    var _primary$guideline_no, _primary$guideline_no2;
    var url = _ref.url, type = _ref.type, label = _ref.label, primary = _ref.primary, items = _ref.items, ind = _ref.ind;
    return /*#__PURE__*/ React.createElement(Wrapper, {
        key: ind,
        id: encodeURIComponent((primary === null || primary === void 0 ? void 0 : primary.guidelines_title) || ind)
    }, /*#__PURE__*/ React.createElement(Info, null, /*#__PURE__*/ React.createElement(SectionMetaContainer, null, primary !== null && primary !== void 0 && primary.guidelines_title ? /*#__PURE__*/ React.createElement(Text, {
        textType: "h2",
        stringText: primary.guidelines_title,
        customStyles: "\n              line-height: 1.25;\n            "
    }) : /*#__PURE__*/ React.createElement("div", null), /*#__PURE__*/ React.createElement(StyledCopy, {
        copyText: url + "#" + encodeURIComponent((primary === null || primary === void 0 ? void 0 : primary.guidelines_title) || ind)
    })), primary !== null && primary !== void 0 && primary.guidelines_summary ? /*#__PURE__*/ React.createElement(Summary, null, /*#__PURE__*/ React.createElement(Text, {
        textType: "displaySmall",
        richText: primary.guidelines_summary.raw
    })) : null), /*#__PURE__*/ React.createElement(Content, {
        isWithNotes: !!(primary !== null && primary !== void 0 && (_primary$guideline_no = primary.guideline_notes) !== null && _primary$guideline_no !== void 0 && _primary$guideline_no.text)
    }, primary !== null && primary !== void 0 && (_primary$guideline_no2 = primary.guideline_notes) !== null && _primary$guideline_no2 !== void 0 && _primary$guideline_no2.text ? /*#__PURE__*/ React.createElement(Notes, null, /*#__PURE__*/ React.createElement(Text, {
        textType: "bodyText",
        richText: primary.guideline_notes.raw
    })) : null, items ? renderModule(type, label, primary, items) : null));
};
export default Module;
